import History from './History'
import './history.css'

export const HISTORY_TAB_ID = `sg_history`
export const HISTORY_TAB_TITLE = `История`
export default History
